import React from 'react'
import styled from 'styled-components'

import { toggleProfitCalculator, toggleFeeBreakdown } from 'actions/index'
import { productType } from 'src/js/types/product'
import { Price } from './Price'

const StyledProductDatabasePriceCell = styled.div`
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: end;
  width: 100%;
`

export const PriceCell = ({ product }) => {
  return (
    <StyledProductDatabasePriceCell>
      <Price
        product={product}
        toggleProfitCalculator={toggleProfitCalculator}
        toggleFeeBreakdown={toggleFeeBreakdown}
      />
    </StyledProductDatabasePriceCell>
  )
}

PriceCell.propTypes = {
  product: productType.isRequired
}
